import React, { FC } from 'react';
import LoadingSkapa, { LoadingBall } from '@ingka/loading';
import { useTranslation } from 'react-i18next';
import { Layout } from '@pcmp/react-coworker-components';

const { Container } = Layout;

export const LoadingState: FC<{
  textI18nKey?: string;
}> = ({ textI18nKey = 'label.loading' }) => {
  const { t } = useTranslation();

  return (
    <LoadingSkapa data-testid="loading" text={t(textI18nKey)}>
      <LoadingBall color="emphasised" size="large" />
    </LoadingSkapa>
  );
};

export const LoadingFullScreen: FC<{
  textI18nKey?: string;
}> = ({ textI18nKey }) => (
  <Container className="h-screen flex align-middle justify-center">
    <LoadingState textI18nKey={textI18nKey} />
  </Container>
);
